import { render } from "./ComponenteGasPreciosMibgas.vue?vue&type=template&id=0b88ad30&scoped=true"
import script from "./ComponenteGasPreciosMibgas.vue?vue&type=script&lang=js"
export * from "./ComponenteGasPreciosMibgas.vue?vue&type=script&lang=js"

import "./ComponenteGasPreciosMibgas.vue?vue&type=style&index=0&id=0b88ad30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b88ad30"]])

export default __exports__